// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { DatapointsComparisonExcelRequestToJSON, DatapointsComparisonRequestToJSON, DatapointsComparisonResponseFromJSON, DatapointsExcelRequestToJSON, DatapointsFundsExcelRequestToJSON, DatapointsRequestToJSON, DatapointsResponseFromJSON, } from '../models';
/**
 * Retrieve datapoints with a POST to avoid GETs with bodies
 * Retrieve datapoints
 */
export function postDatapointsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints` + queryString,
        meta,
        update: requestConfig.update || {
            Datapoints: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsRequestToJSON(requestParameters.datapointsRequest),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = DatapointsResponseFromJSON(body);
            if (body.id) {
                return { Datapoints: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { Datapoints: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostDatapoints-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Retrieve datapoints with a POST to avoid GETs with bodies
* Retrieve datapoints
*/
/**
 * Mutation hook to create a Client
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an array client
 */
export const usePostDatapoints = (customQueryConfig) => {
    return useMutation((datapointsRequest, customQueryParam) => postDatapointsRaw({ datapointsRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postDatapoints(requestParameters, requestConfig) {
    return postDatapointsRaw(requestParameters, requestConfig);
}
/**
 * Retrieve and compare datapoints of multiple entities with a POST to avoid GETs with bodies
 * Retrieve datapoints comparison
 */
export function postDatapointsComparisonRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/comparison` + queryString,
        meta,
        update: requestConfig.update || {
            Datapoints: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsComparisonRequestToJSON(requestParameters.datapointsComparisonRequest),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = DatapointsComparisonResponseFromJSON(body);
            if (body.id) {
                return { Datapoints: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { Datapoints: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsComparison-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Retrieve and compare datapoints of multiple entities with a POST to avoid GETs with bodies
* Retrieve datapoints comparison
*/
/**
 * Mutation hook to upsert an DatapointsComparisonResponse
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an DatapointsComparisonResponse
 */
export const usePostDatapointsComparison = (customQueryConfig) => {
    return useMutation((datapointsComparisonRequest, customQueryParam) => postDatapointsComparisonRaw({ datapointsComparisonRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postDatapointsComparison(requestParameters, requestConfig) {
    return postDatapointsComparisonRaw(requestParameters, requestConfig);
}
/**
 * For debugging purposes, retrieves the query(ies) sent to PACE given the same input as /datapoints endpoint
 * Retrieve datapoints query sent to PACE
 */
export function postDatapointsDebuggingRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/debugging` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsRequestToJSON(requestParameters.datapointsRequest),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsDebugging-${objectToHash(requestParameters)}`;
    return config;
}
/**
* For debugging purposes, retrieves the query(ies) sent to PACE given the same input as /datapoints endpoint
* Retrieve datapoints query sent to PACE
*/
export function postDatapointsDebugging(requestParameters, requestConfig) {
    return postDatapointsDebuggingRaw(requestParameters, requestConfig);
}
/**
 * Generates an Excel file with with a POST datapoints call to avoid GETs with bodies
 * Generates an Excel export for datapoints
 */
export function postDatapointsExcelRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/excel` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsExcelRequestToJSON(requestParameters.datapointsExcelRequest),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsExcel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Generates an Excel file with with a POST datapoints call to avoid GETs with bodies
* Generates an Excel export for datapoints
*/
export function postDatapointsExcel(requestParameters, requestConfig) {
    return postDatapointsExcelRaw(requestParameters, requestConfig);
}
/**
 * Generates an Excel file for comparison with with a POST datapoints call to avoid GETs with bodies
 * Generates an Excel export for comparison datapoints
 */
export function postDatapointsExcelComparisonRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/excel-comparison` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsComparisonExcelRequestToJSON(requestParameters.datapointsComparisonExcelRequest),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsExcelComparison-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Generates an Excel file for comparison with with a POST datapoints call to avoid GETs with bodies
* Generates an Excel export for comparison datapoints
*/
export function postDatapointsExcelComparison(requestParameters, requestConfig) {
    return postDatapointsExcelComparisonRaw(requestParameters, requestConfig);
}
/**
 * For debugging purposes, retrieves the query(ies) sent to PACE given the same input as /datapoints endpoint
 * Retrieve datapoints query sent to PACE fro Excel request
 */
export function postDatapointsExcelDebuggingRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/excel/debugging` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsExcelRequestToJSON(requestParameters.datapointsExcelRequest),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsExcelDebugging-${objectToHash(requestParameters)}`;
    return config;
}
/**
* For debugging purposes, retrieves the query(ies) sent to PACE given the same input as /datapoints endpoint
* Retrieve datapoints query sent to PACE fro Excel request
*/
export function postDatapointsExcelDebugging(requestParameters, requestConfig) {
    return postDatapointsExcelDebuggingRaw(requestParameters, requestConfig);
}
/**
 * Generates an Excel file for Funds grid
 * Generates an Excel export for Funds grid
 */
export function postDatapointsFundsExcelRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/funds/excel` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsFundsExcelRequestToJSON(requestParameters.datapointsFundsExcelRequest),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsFundsExcel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Generates an Excel file for Funds grid
* Generates an Excel export for Funds grid
*/
export function postDatapointsFundsExcel(requestParameters, requestConfig) {
    return postDatapointsFundsExcelRaw(requestParameters, requestConfig);
}
